import React, { useEffect } from "react";
import "./HomePage.scss";
import { whyUs } from "../../data/general";
import { Helmet } from "react-helmet";
import SlideUpAnimation from "../../components/SlideUpAnimation/SlideUpAnimation";
import Hero from "./Hero";
import BuyersSection from "./BuyersSection";
import PropertymarkBanner from "../../components/PropertymarkBanner/PropertymarkBanner";
import PropertiesPewview from "./PropertiesPewview";
import ListingIntelligenceSection from "./ListingIntelligenceSection";
import RecentlyViewedCarousel from "../../components/RecentlyViewed/RecentlyViewedCarousel";
import AreaGuideTeaser from "../../components/AreaGuide/AreaGuideTeaser";
import AboutAndContactForm from "../../components/AboutAndContactForm/AboutAndContactForm";

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <>
      <Helmet>
        <title>Letting Engine</title>
        <meta
          name="description"
          content="Buy luxury property in London through NVRE, with Letting Engine's expert tools and area insight. We also offer premium rentals and landlord services across the capital."
        />
        <meta
          name="keywords"
          content="buy property london, luxury homes, NVRE, property sales, rentals, landlords, letting agency, london real estate"
        />
      </Helmet>
      <div className="home-page-container">
        <Hero />
        <PropertymarkBanner />
        <BuyersSection />
        <PropertiesPewview />
        <ListingIntelligenceSection />
        <RecentlyViewedCarousel />
        <AreaGuideTeaser />
        <section className="relative bg-[#1a1a1a] text-white py-32 md:py-40">
          <div className="max-w-[1440px] mx-auto px-[5%]">
            <div className="mb-16 relative pl-8 border-l-2 border-l-solid border-l-brand-yellow">
              <SlideUpAnimation triggerOnce={false}>
                <span className="font-manrope text-xs tracking-wider uppercase text-white/60 block mb-2">
                  Advantages
                </span>
                <h2 className="page-section-heading text-brand-yellow">
                  Why Choose Letting Engine?
                </h2>
              </SlideUpAnimation>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {whyUs.map((i, index) => (
                <SlideUpAnimation
                  key={i.header}
                  triggerOnce={true}
                  delay={(index + 1) * 0.2}
                >
                  <div className="w-full h-full bg-[rgba(255,255,255,0.04)] border border-solid border-[rgba(255,255,255,0.12)] p-8 transition-all duration-300 ease-lux cursor-default relative hover:bg-brand-yellow hover:text-text-obsidian hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(0,0,0,0.35)] group">
                    <div className="absolute top-0 left-0 w-full h-1 bg-brand-yellow transition-all duration-300 group-hover:bg-text-obsidian" />
                    <span className="font-teko text-4xl text-brand-yellow/40 leading-none mb-3 block group-hover:text-text-obsidian/30">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-teko text-xl mb-3">{i.header}</h3>
                    <p className="font-manrope text-base text-white/75 leading-relaxed group-hover:text-white">
                      {i.p}
                    </p>
                  </div>
                </SlideUpAnimation>
              ))}
            </div>
          </div>
        </section>
        <AboutAndContactForm />
      </div>
    </>
  );
}
